import { Container, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import servicesBg from '../../../../images/Group 1.png';
import cardLeftBg from '../../../../images/Rectangle 283.png';
import cardRightBg from '../../../../images/Rectangle 284.png';
import leftBg from '../../../../images/Vector 68.png';
import rightBg from '../../../../images/Vector 67.png';
import Service from '../Service/Service';

const servicesTextBg = {
    backgroundImage: `url(${servicesBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}
const servicesLeftBg = {
    backgroundImage: `url(${cardLeftBg})`,
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat'
}
const servicesRightBg = {
    backgroundImage: `url(${cardRightBg})`,
    backgroundPosition: 'right top',
    backgroundRepeat: 'no-repeat'
}
const stateLeftBg = {
    backgroundImage: `url(${leftBg})`,
    backgroundPosition: 'left 2% bottom',
    backgroundRepeat: 'no-repeat'
}
const stateRightBg = {
    backgroundImage: `url(${rightBg})`,
    backgroundPosition: 'right 2% bottom 20%',
    backgroundRepeat: 'no-repeat'
}

const Services = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        fetch(`./HomeServices.json`)
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])
    return (
        <div style={stateLeftBg}>
            <Box style={stateRightBg}>
                <Container sx={{ mt: 6 }}>
                    <Box style={servicesTextBg} sx={{ textAlign: 'left' }}>
                        <Typography variant="h6" id="service-start" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                            Services
                        </Typography>
                        <Typography variant="h3" id="service-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                            We Help Your Business Grow With
                        </Typography>
                    </Box>
                </Container>
                <Box style={servicesLeftBg}>
                    <Box style={servicesRightBg}>
                        <Container sx={{ py: 4 }}>
                            <Grid container spacing={4}>
                                {
                                    services.map(service => <Service
                                        key={service.id}
                                        service={service}
                                    ></Service>)
                                }
                            </Grid>
                        </Container>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default Services;